export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col bg-background-50 overflow-hidden">
      {/* Top bar with company title */}
      <header className="w-full px-8 md:px-16 py-6 flex items-center">
        <h1 className="text-sm md:text-base font-bold uppercase tracking-[0.25em] text-foreground-900 font-sans whitespace-nowrap">
          (Kasar Software OU)
        </h1>
      </header>

      {/* Main hero content */}
      <div className="flex-1 flex flex-col lg:flex-row items-center lg:items-start w-full">
        {/* Left text zone - 40% */}
        <div className="w-full lg:w-[40%] flex flex-col justify-center px-8 md:px-16 pt-8 lg:pt-24 pb-12 lg:pb-24">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-[1.1] max-w-lg">
            Engineering the future of digital experiences
          </h2>
          <p className="mt-8 text-base md:text-lg text-foreground-700 leading-relaxed max-w-md font-body font-normal">
            A professional engineering team focused on designing and developing modern digital software solutions for the iOS platform and related technologies. We build scalable, maintainable, and high-performance systems with a strong focus on usability, stability, and long-term technical quality.
          </p>
        </div>

        {/* Right decorative zone - 60% */}
        <div className="w-full lg:w-[60%] relative flex-1 min-h-[400px] lg:min-h-0 flex items-center justify-center">
          {/* Abstract geometric composition */}
          <div className="relative w-full h-full max-w-2xl max-h-[600px]">
            {/* Large soft gradient blob */}
            <div
              className="absolute top-[10%] right-[15%] w-72 h-72 md:w-96 md:h-96 rounded-full opacity-40"
              style={{
                background: 'radial-gradient(circle, oklch(0.58 0.13 35 / 0.5), oklch(0.72 0.04 82 / 0.2), transparent)',
                filter: 'blur(50px)',
              }}
            />
            {/* Medium warm blob */}
            <div
              className="absolute bottom-[20%] left-[10%] w-56 h-56 md:w-80 md:h-80 rounded-full opacity-35"
              style={{
                background: 'radial-gradient(circle, oklch(0.54 0.16 25 / 0.4), oklch(0.93 0.025 84 / 0.15), transparent)',
                filter: 'blur(45px)',
              }}
            />
            {/* Small accent circle */}
            <div
              className="absolute top-[35%] left-[25%] w-40 h-40 md:w-52 md:h-52 rounded-full opacity-25"
              style={{
                background: 'radial-gradient(circle, oklch(0.74 0.09 35 / 0.4), transparent)',
                filter: 'blur(30px)',
              }}
            />
            {/* Subtle mesh overlay circle */}
            <div
              className="absolute top-[50%] right-[10%] w-48 h-48 md:w-64 md:h-64 rounded-full opacity-20"
              style={{
                background: 'radial-gradient(circle at 30% 30%, oklch(0.83 0.04 82 / 0.6), oklch(0.60 0.035 82 / 0.2), transparent)',
                filter: 'blur(20px)',
              }}
            />
            {/* Small floating ellipse */}
            <div
              className="absolute bottom-[40%] right-[30%] w-28 h-36 md:w-36 md:h-44 rounded-[60%] opacity-20"
              style={{
                background: 'linear-gradient(135deg, oklch(0.54 0.16 25 / 0.35), oklch(0.58 0.13 35 / 0.25))',
                filter: 'blur(15px)',
                transform: 'rotate(-15deg)',
              }}
            />
            {/* Tiny dot accent */}
            <div className="absolute top-[25%] right-[40%] w-6 h-6 rounded-full bg-accent-500/30" />
            <div className="absolute bottom-[30%] left-[35%] w-3 h-3 rounded-full bg-primary-400/25" />
          </div>
        </div>
      </div>
    </section>
  );
}